import React, { useEffect, useState } from 'react';
import { Modal, Button, Table } from 'antd';
import moment from 'moment';
import { ImmoService } from '../Services/ImmoService';

const ImmobilisationDetailModal = ({ isVisible, onClose, immobilisation }) => {
  const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    const immoService = new ImmoService();

    useEffect(() => {
        if (isVisible && immobilisation) {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const data = await immoService.getDetailImmo(immobilisation.code);
                    setTableData(data);
                } catch (error) {
                    console.error('Erreur lors de la récupération des détails de l\'immobilisation :', error);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [isVisible, immobilisation, ]);
    if (!immobilisation) {
        return null; // Ou retourner un contenu alternatif si tu préfères
    }
    const dataSource = [immobilisation];
    const detailColumns = [
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
       Exercice
          </div>
        ),
       
        dataIndex: 'exercice',
        key: 'exercice',
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
        ),
      },
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
        Valeur début
          </div>
        ),
       
        dataIndex: 'valdeb',
        key: 'valdeb',
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
        ),
      },
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
        Valeur Fin
          </div>
        ),
        dataIndex: 'valfin',
        key: 'valfin',
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
        ),
      },
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
        Dot. amort
          </div>
        ),
       
          dataIndex: 'dotamort',
          key: 'dotamort',
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
        ),
      },
     
      
  ];
  
    const columns = [
      {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                paddingRight: 5,
              }}
            >
           Base d'amortissement
            </div>
          ),
          dataIndex: "val_acquis",
          key: "val_acquis",
          align: "right",
          render: (text) => (
            <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
          ),
        },
      {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                paddingRight: 5,
              }}
            >
            Durée
            </div>
          ),
          dataIndex: "duree_amort",
          key: "duree_amort",
          align: "right",
          render: (text) => (
            <div style={{ paddingRight: 10 }}>{parseFloat(immobilisation.duree_amort)}</div>
          ),
        },
    
    
      {
        title: 'Date mise en service',
        dataIndex: 'date_mes',
        key: 'date_mes',
        align : 'center',
        render: (text, record) => (
          <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
            {moment(immobilisation.date_mes).locale("fr").format("DD MMM YYYY")}
          </div>
        ),
      },
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              paddingRight: 5,
            }}
          >
          Taux
          </div>
        ),
        dataIndex: "taux",
        key: "taux",
        align: "right",
        render: (text) => (
          <div style={{ paddingRight: 10 }}>{parseFloat(immobilisation.taux)} %</div>
        ),
      },
    
    ];
    return (
        <Modal
            title="Détail de l'immobilisation"
            visible={isVisible}
            onCancel={onClose}
            maskClosable={false}
            footer={[
                <Button key="back" onClick={onClose}>
                    Fermer
                </Button>
            ]}
        >
            <h1 style={{textAlign:"center"}}>{immobilisation.code} - {immobilisation.designation}</h1>
           
            <Table
            className="custom-header2-table"
            bordered
            showSorterTooltip={false}
            columns={columns}
            dataSource={dataSource} 
          />

          <Table
                loading={loading}
                dataSource={tableData}
                columns={detailColumns}
                
                className="custom-header2-table"
                bordered
            />
        </Modal>
    );
};

export default ImmobilisationDetailModal;
